export const PROJECTS_CONSTS = {
    GET_PROJECTS_LIST: "GET_PROJECTS_LIST",
    GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
    CREATE_PROJECTS: "CREATE_PROJECTS",
    UPDATE_PROJECTS_POSITIONS: "UPDATE_PROJECTS_POSITIONS",
    UPDATE_PROJECTS_BY_ID: "UPDATE_PROJECTS_BY_ID",
    DELETE_PROJECTS_BY_ID: "DELETE_PROJECTS_BY_ID",
};